import { render, staticRenderFns } from "./IconChatbot.vue?vue&type=template&id=d967bc04&"
import script from "./IconChatbot.vue?vue&type=script&lang=js&"
export * from "./IconChatbot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports